"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = AlignCenter;

var _AlignCenter = require("@adobe/react-spectrum-workflow/dist/AlignCenter");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function AlignCenter(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_AlignCenter.A4uAlignCenter, null));
}